export interface Wrappers {
    HEAD?: string;
    HEADER?: string;
    CONTEXTHUB?: string;
    FOOTER?: string;
    GLOBALJS?: string;
    RIGHT_RAIL?: string;
    FIRST_AD?: string;
    COMMUNITY_AD?: string;
    MEMBERSHIP_AD?: string;
    PROMO_AD?: string;
    // Second should only be present on the Home and Category pages, and not on the game pages.
    SECOND_AD?: string;
    NEW_RIGHT_RAIL?: string;
    LEADERBOARD?: string;
}

export enum WrapperKeys {
    HEAD = 'HEAD',
    HEADER = 'HEADER',
    CONTEXTHUB = 'CONTEXTHUB',
    FOOTER = 'FOOTER',
    GLOBALJS = 'GLOBALJS',
    RIGHT_RAIL = 'RIGHT_RAIL',
    FIRST_AD = 'FIRST_AD',
    COMMUNITY_AD = 'COMMUNITY_AD',
    MEMBERSHIP_AD = 'MEMBERSHIP_AD',
    PROMO_AD = 'PROMO_AD',
    SECOND_AD = 'SECOND_AD',
    NEW_RIGHT_RAIL = 'NEW_RIGHT_RAIL',
    LEADERBOARD = 'LEADERBOARD',
}
